import { styled, Typography } from "@mui/material";

export const StyledPlanillas = {
    GrupoTitulo: styled(Typography)(({ theme }) => ({
        display: "flex",
        margin: 15,
        color: theme.palette.primary.main,
        borderBottom: `solid 2px ${theme.palette.primary.main}`,
    })),
    FechaPresentacionContainer: styled(Typography)(({ theme }) => ({
        display: "flex",
        marginLeft: 15,
    })),
}